import storeManager from '../../store/StoreManager';
import {
    moveShape,
    setCurrentSlide,
    updateTextProperties,
    setCloneTarget,
    selectShape,
    updateCurrentSlideThumbnail,
    duplicateShape,
    deleteShape,
    updateCurrentSlideIndex,
    canvasUndoRedoAction,
    selectLastAddedShape,
    updateHospot,
    updateCroppingHospot
} from '../../actions/CurrentSlideActions';
import { shiftSlide, setSlideCloneTarget, cloneSlide, updateCurrentSlide, deleteSlide, productionUndoRedoAction } from '../../actions/ProductionActions';
import {hideMenus, changeContextMode, showZoomSlides, showCroppingMenu} from '../../actions/MenuActions';
import { undo, redo } from '../../actions/UndoRedoActions';
import { audioEditorUndoRedo, deleteItem } from '../../actions/AudioEditorActions';
import { needsRefresh} from '../../actions/SlideViewerActions';
import properties from '../../constants/Properties';
import menuConstants from '../../constants/MenuType';
import previewCommands from '../utils/PreviewCommands';
import textSizeUtils from '../utils/TextSizeUtils';
import { isTextBox } from '../utils/TransformToolUtils';
import mouseUtils from '../utils/MouseUtils';
import zoomUtils from '../utils/ZoomUtils';
import platformDetection from '../utils/PlatformDetection';
import selectionManager from '../utils/SelectionManager';
import groupManager from '../utils/GroupManager';
import videoUtils from '../utils/VideoUtils';
import modeType from '../../constants/ModeConstants';
import drawingUtils from '../utils/DrawingUtils';
import playController from './PlayController';
import saveManager from './SaveManager';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import hoverManager from './HoverManager';
import slidesUtils from './SlidesUtils';
import audioToolUtils from '../audioTool/utils/AudioToolUtils';
import animationManager from './AnimationManager';
import helpUtils from './HelpUtils';
import appParameters from './AppParameters';
import exportPlayerController from './ExportPlayerController';
import textEditorUtils from '../menus/textEditorTool/utils/TextEditorUtils';
import mindMapUtils from "./MindMapUtils";

function isSlideCommand() {
    const state = storeManager.getState();
    const isSlideComand = state.currentSlide.isSlideCommand;

    if (isSlideComand == true)
        return true;
    else
        return false;
}

function isAudioEditorMode () {
    const state = storeManager.getState();
    const showAudioEditor = state.menu.showAudioEditor;

    if (showAudioEditor == true || audioToolUtils.isAudioTool())
        return true;
    else
        return false;
}

function getShapeTarget() {
    const state = storeManager.getState();
    const target = state.currentSlide.shortcutsTarget;

    return target;
}

function isAvailable(keyCode) {
    var activeElement = document.activeElement;

    if (activeElement && activeElement.nodeName == 'BUTTON' && keyCode == 32) // if is SPACE and a native button is selected then execute only the click on that button
        return false;

    // in TextEditorMode we shouldn't have the shourtcuts activate BUT only TAB
    if (textEditorUtils.isTextEditorTool())
        return false;

    if (textEditorUtils.isInteractiveTextElementFocused() && keyCode == 70) // if F key is pressed then don't enter in FULLSCREEN mode and just enter to TEXT EDITOR TOOL
        return false;

    const state = storeManager.getState();
    const mode = state.production.mode;
    const showAlternativeTextMenu = state.menu.showAlternativeTextMenu;

    if (showAlternativeTextMenu)
        return false;

    if (animationManager.isAnimationMode() && keyCode != 27 && keyCode != 13)
        return false;

    if (keyCode == 70) // F --> fullScreen should be available for all tools either is Edit or Player mode
        return true;

    if (mode == modeType.PLAYER || mode == modeType.PREVIEW || audioToolUtils.isAudioPlayer() || appParameters.context == modeType.EXPORT_PLAYER || appParameters.context == modeType.EXPORT_AUDIO_PLAYER) { // it's Cartoonist Player/Preview or AudioPlayer or Cartoonist export or AudioEditor export
        if (mode == modeType.PREVIEW && keyCode == 27) // ESC - is used to exit from Preview mode
            return true;

        if (keyCode == 37 || keyCode == 39 || keyCode == 32) // Space, Left and Right arrow should be available
            return true;
        else
            return false;
    }

    if (document.activeElement.className.indexOf('sliderThumb') != -1)
        return false;

    return true;
}

function isDrawingMode() {
    const state = storeManager.getState();
    const contextMode = state.menu.contextMode;

    if (contextMode == modeType.FREEHAND_CONTEXT || contextMode == modeType.LINE_CONTEXT)
        return true;
    else
        return false;
}

export function checkKeyboardCommand (event, dispatch) {
    if (isAvailable(event.keyCode) == false)
        return;

    if (isDurationFocus()) {
            if (event.keyCode == 13) { // ENTER
                document.activeElement.blur();
            }
        return;
    }

    if (event.ctrlKey == true && event.shiftKey == false) {
        switch (event.keyCode) {
            case 90: { // Ctrl + Z -- > Undo
                undoAction(dispatch);
                break;
            }

            case 89: { // Ctrl + Y -- > Redo
                redoAction(dispatch);
                break;
            }

            case 67: { // Ctrl + C -- > Copy
                if (isSlideCommand()) {
                    copySlide(dispatch);
                } else {
                    copyShape(dispatch);
                }
                break;
            }

            case 88: { // Ctrl + X -- > Cut
                if (isSlideCommand()) {
                    cutSlide(dispatch);
                } else {
                    cutShape(dispatch);
                }
                break;
            }

            case 86: { // Ctrl + V -- > Paste
                if (isSlideCommand() && !selectionManager.copiedCanvasElement) {
                    pasteSlide(dispatch);
                } else {
                    pasteShape(dispatch);
                }
                break;
            }

            case 71: { // Ctrl + G -- > Group/Ungroup
                groupManager.groupUngroup();
                saveManager.isContentChanged(true);
                break;
            }

            case 65: { // CTRL + A --> Select all
                selectionManager.selectAll();
                break;
            }
        }

    } else if (event.ctrlKey == false && event.shiftKey == true) {
        switch (event.keyCode) {
            case 37: { // LEFT --> MoveLeft with big step
                if (previewCommands.isEditorMode() == false) {
                    return;
                }

                if (isSlideCommand() == true) {
                    changeSlidePosition(dispatch, true);
                } else {
                    changeShapePosition(dispatch, -properties.MOVE_SHAPE_BIG_OFFSET, 0);
                }
                break;
            }

            case 39: { // RIGHT --> MoveRight with big step
                if (previewCommands.isEditorMode() == false) {
                    return;
                }

                if (isSlideCommand() == true) {
                    changeSlidePosition(dispatch, false);
                } else {
                    changeShapePosition(dispatch, properties.MOVE_SHAPE_BIG_OFFSET, 0);
                }
                break;
            }

            case 38: { // TOP --> MoveTop with big step
                if (isSlideCommand() == false) {
                    changeShapePosition(dispatch, 0, - properties.MOVE_SHAPE_BIG_OFFSET);
                }
                break;
            }

            case 40: { // DOWN --> MoveDown with big step
                if (isSlideCommand() == false) {
                    changeShapePosition(dispatch, 0, properties.MOVE_SHAPE_BIG_OFFSET);
                }
                break;
            }

            case 83: { // Shift + S -- > Save
                if (!isTextFocus())
                    openSaveMenu(dispatch);
                break;
            }
        }
    } else if (event.ctrlKey == false && event.shiftKey == false && event.altKey == false) { // No Shift and No Ctrl and No ALT
            const state = storeManager.getState();
            const showZoomSlidesValue = state.menu.showZoomSlides;
            const showCroppingMenuValue = state.menu.showCroppingMenu;
            const isVideoEditor = state.menu.showVideoEditor;

            switch (event.keyCode) {
                case 107: //+
                    if(showZoomSlidesValue){
                        updateSlideZoom("zoomIn")
                    }
                    break;
                case 109: //-
                    if(showZoomSlidesValue){
                        updateSlideZoom("zoomOut")
                    }
                    break;
                case 37: { // LEFT --> MoveLeft with normal step
                    if(showZoomSlidesValue){
                        updateSlideZoom("left")
                    }
                    if (appParameters.context == modeType.EXPORT_PLAYER || appParameters.context == modeType.EXPORT_AUDIO_PLAYER) {
                        if (exportPlayerController.keyboardShortcutAction)
                            exportPlayerController.keyboardShortcutAction('left');

                        return;
                    }

                    if (audioToolUtils.isAudioPlayer()) {
                        if (audioToolUtils.audioPlayerKeyboardShortcutAction)
                            audioToolUtils.audioPlayerKeyboardShortcutAction(1);

                        return;
                    }

                    if (playController.isAudioEditorMode() && !isSlideCommand()) {
                        playController.executeAction('left');
                        return;
                    }

                    if (previewCommands.isEditorMode() == false) {
                        previewCommands.executeCommand(1);
                        return;
                    }

                    if (isSlideCommand() == true) {
                        changeCurrentSlide(dispatch, true);
                    } else {
                        changeShapePosition(dispatch, - properties.MOVE_SHAPE_OFFSET, 0);
                    }
                    break;
                }

                case 39: { // RIGHT --> MoveRight with normal step
                    if(showZoomSlidesValue){
                        updateSlideZoom("right")
                    }

                    if (appParameters.context == modeType.EXPORT_PLAYER || appParameters.context == modeType.EXPORT_AUDIO_PLAYER) {
                        if (exportPlayerController.keyboardShortcutAction)
                            exportPlayerController.keyboardShortcutAction('right');

                        return;
                    }

                    if (audioToolUtils.isAudioPlayer()) {
                        if (audioToolUtils.audioPlayerKeyboardShortcutAction)
                            audioToolUtils.audioPlayerKeyboardShortcutAction(3);

                        return;
                    }

                    if (playController.isAudioEditorMode() && !isSlideCommand()) {
                        playController.executeAction('right');
                        return;
                    }

                    if (previewCommands.isEditorMode() == false) {
                        previewCommands.executeCommand(3);
                        return;
                    }

                    if (isSlideCommand() == true) {
                        changeCurrentSlide(dispatch, false);
                    } else {
                        changeShapePosition(dispatch, properties.MOVE_SHAPE_OFFSET, 0);
                    }
                    break;
                }

                case 38: { // TOP --> MoveTop with normal step
                    if(showZoomSlidesValue){
                        updateSlideZoom("up")
                    }

                    if (isSlideCommand() == false) {
                        changeShapePosition(dispatch, 0, - properties.MOVE_SHAPE_OFFSET);
                    }
                    break;
                }

                case 40: { // DOWN --> MoveDown with normal step
                    if(showZoomSlidesValue){
                        updateSlideZoom("down")
                    }

                    if (isSlideCommand() == false) {
                        changeShapePosition(dispatch, 0, properties.MOVE_SHAPE_OFFSET);
                    }
                    break;
                }

                case 8:   // BACKSPACE
                case 46: { // DELETE --> Delete element on canvas
                    hoverManager.hide();

                    var selection = getSelection();

                    if (isAudioEditorMode() && !isTextFocus()) {
                        if (selection == undefined || selection.length < 1) {
                            dispatch(deleteItem());
                            saveManager.isContentChanged(true);
                            audioEditorUtils.addActionToHistory();
                            audioEditorUtils.checkTimelineWidth();
                            break;
                        }
                    }

                    if (isSlideCommand() == false) {
                        var element = document.activeElement;

                        if ((selection == undefined || selection.length < 1) && element.className.indexOf('titleInput') == -1) {
                            event.preventDefault();
                        }

                        if (isTextFocus()) {
                            // it's an active text element so we shouldn't do something here
                        } else
                            deleteObject(dispatch);
                    }
                    break;
                }

                case 27: { // Escape --> Exit PREVIEW mode
                    if (animationManager.isAnimationMode()) {
                        animationManager.clearAnimationsInEditMode(true);
                        animationManager.exitAnimationMode();
                        return;
                    }

                    if (isAudioEditorMode()) {
                        playController.toggleAudioEditorMode();
                        dispatch(hideMenus(menuConstants.ALL_MENUS));
                        break;
                    }

                    if (isDrawingMode()) {
                        drawingUtils.executeAction('cancel');
                    } else {
                        if (isVideoEditor) {
                            videoUtils.executeAction('cancel');
                        } else {
                            if (showZoomSlidesValue) {
                                dispatch(showZoomSlides(false));
                            } else if (showCroppingMenuValue) {
                                dispatch(updateCurrentSlide());
                                dispatch(updateCurrentSlideThumbnail(true));
                                dispatch(selectShape(''));
                                dispatch(showCroppingMenu(false));
                            } else {
                                previewCommands.exitPreview();
                            }
                        }
                    }

                    break;
                }

                case 13: { // ENTER --> ZOOM IN
                    if (helpUtils.titleAlertVisible && helpUtils.closeTitleAlert) {
                        helpUtils.closeTitleAlert();
                        return;
                    }

                    /*if (animationManager.isAnimationMode()) {
                        animationManager.clearAnimationsInEditMode();
                        animationManager.addAnimation();
                        saveManager.isContentChanged(true);
                        return;
                    }*/

                    if (isVideoEditor) {
                        videoUtils.executeAction('ok');
                        saveManager.isContentChanged(true);
                        return;
                    }

                    if (showZoomSlidesValue) {
                        zoomIn(dispatch);
                        return;
                    }

                    if (showCroppingMenuValue) {
                        cropElement(dispatch);
                        return;
                    }

                    if (playController.isAudioEditorAvailable() && !selectionManager.isTextBoxSelected() && !selectionManager.isSaveContext() && !isTextFocus()) {
                        playController.executeAction('stop');
                        return;
                    }

                    break;
                }

                case 32:{ // SPACE --> Play/Stop in Preview mode
                    if (appParameters.context == modeType.EXPORT_PLAYER || appParameters.context == modeType.EXPORT_AUDIO_PLAYER) {
                        setTimeout(function() {
                            if (exportPlayerController.keyboardShortcutAction)
                                exportPlayerController.keyboardShortcutAction('space');
                        }.bind(this), 30);

                        return;
                    }

                    if (audioToolUtils.isAudioPlayer()) {
                        setTimeout(function() {
                            if (audioToolUtils.audioPlayerKeyboardShortcutAction)
                                audioToolUtils.audioPlayerKeyboardShortcutAction(2);
                        }.bind(this), 30);

                        return;
                    }

                    if (isVideoEditor) {
                        videoUtils.executeAction('play');
                        return;
                    }

                    if (playController.isAudioEditorAvailable() && !selectionManager.isTextBoxSelected() && !selectionManager.isSaveContext() && !isTextFocus()) {
                        playController.executeAction('play');

                        if (previewCommands.forceUpdateForPlayButton)
                            previewCommands.forceUpdateForPlayButton();

                        return;
                    }

                    if (!playController.isAudioEditorAvailable()) {
                        if (previewCommands.isEditorMode() == false) {
                            previewCommands.executeCommand(2);

                            if (previewCommands.forceUpdateForPlayButton)
                                previewCommands.forceUpdateForPlayButton();
                        } else {
                            if (videoUtils.isVideoBackground() && videoUtils.playRegular && !selectionManager.isTextBoxSelected() && !selectionManager.isSaveContext() && !isTextFocus())
                                videoUtils.playRegular();
                        }
                    }

                    break;
                }

                case 70: { // Ctrl + F -- > Fullscreen
                    if (previewCommands.isPlayer()) {
                        previewCommands.goFullScreenMode();
                        return;
                    }

                    if (isTextFocus()) {
                        // it's an active text element so we shouldn't do something here
                    } else
                        zoomUtils.goToFullScreenMode();
                    break;
                }

                case 67: { // Command + C -- > Copy for MAC
                    if (event.metaKey && platformDetection.isMac()) {
                        if (isSlideCommand() == true) {
                            copySlide(dispatch);
                        } else {
                            copyShape(dispatch);
                        }
                    }
                    break;
                }

                case 88: { // Command + X -- > Cut for MAC
                    if (event.metaKey && platformDetection.isMac()) {
                        if (isSlideCommand() == true) {
                            cutSlide(dispatch);
                        } else {
                            cutShape(dispatch);
                        }
                    }
                    break;
                }

                case 86: { // Command + V -- > Paste for MAC
                    if (event.metaKey && platformDetection.isMac()) {
                        if (isSlideCommand() && !selectionManager.copiedCanvasElement) {
                            pasteSlide(dispatch);
                        } else {
                            pasteShape(dispatch);
                        }
                    }
                    break;
                }
            }
    } else if (event.altKey == true) { // ALT key is down
        switch (event.keyCode) {
            case 66: { // ALT + B -- > Bold
                changeFontProperties(dispatch, 'fontBold');
                break;
            }

            case 73: { // ALT + I -- > Italic
                changeFontProperties(dispatch, 'fontItalic');
                break;
            }

            case 85: { // ALT + U -- > Underline
                changeFontProperties(dispatch, 'fontUnderline');
                break;
            }

            case 187: { // ALT++ --> Increase font size
                changeFontProperties(dispatch, 'fontSize', 1);
                break;
            }

            case 189: { // ALT+- --> Decrease font size
                changeFontProperties(dispatch, 'fontSize', -1);
                break;
            }
        }
    }
}

function zoomIn(dispatch) {
    dispatch(updateHospot(zoomUtils.currentBackgroundUid, zoomUtils.currentHotspot));
    audioEditorUtils.addActionToHistory();
    dispatch(updateCurrentSlide());
    dispatch(updateCurrentSlideThumbnail(true));
    dispatch(showZoomSlides(false));
    saveManager.isContentChanged(true);
}

function cropElement(dispatch) {
    dispatch(updateCroppingHospot(zoomUtils.croppingTarget.uuid, zoomUtils.currentCroppingHotspot));
    audioEditorUtils.addActionToHistory();
    dispatch(updateCurrentSlide());
    dispatch(updateCurrentSlideThumbnail(true));
    dispatch(showCroppingMenu(false));
    saveManager.isContentChanged(true);
}

function getSelection () {
    const state = storeManager.getState();
    const shapes = state.currentSlide.model.content;
    var i;
    var selection = [];

    for (i=0; i<shapes.length; i++)
        if (shapes[i].isSelected == true) {
            selection.push(shapes[i].uuid);
        }

    return selection;
}

function getSelectedShape () {
    const state = storeManager.getState();
    const shapes = state.currentSlide.model.content;
    var i;
    var target;

    for (i=0; i<shapes.length; i++)
        if (shapes[i].isSelected == true) {
            target = shapes[i];
            break;
        }

    return target;
}

function deleteObject (dispatch) {
    const state = storeManager.getState();

    if (state.menu.contextMode == modeType.SAVE_CONTEXT)
        return;

    var shapeModels = getSelection();

    if (shapeModels == undefined || shapeModels.length < 1)
        return;

    if (shapeModels.length == 1 && isTextBox(shapeModels[0]) == true)
        return;

    dispatch(deleteShape(shapeModels));
    dispatch(selectShape(''));
    audioEditorUtils.addActionToHistory();
    updateThumbnail(dispatch);
    saveManager.isContentChanged(true);
}

function updateThumbnail(dispatch) {
    dispatch(updateCurrentSlideThumbnail(true));
}

function changeShapePosition (dispatch, offsetX, offsetY) {
    const shapeModel = getSelectedShape();

    if (shapeModel == undefined || isTextFocus())
        return;

    const state = storeManager.getState();
    const contextMode = state.menu.contextMode;

    if (contextMode == modeType.SIZE_AND_POSITION_CONTEXT)
        return;

    dispatch(moveShape(shapeModel.uuid, offsetX, offsetY));
    mindMapUtils.moveShapeByKeyboard(shapeModel, offsetX, offsetY);
    audioEditorUtils.addActionToHistory();
    saveManager.isContentChanged(true);
}

function changeCurrentSlide (dispatch, isLeftPosition) {
    const state = storeManager.getState();
    const currentIndex = state.currentSlide.currentSlideIndex;
    const slides = state.production.slides;

    mouseUtils.isKeyboardShortcut = true;

    if (isLeftPosition == true) {
        if (currentIndex > 0) {
            dispatch(setCurrentSlide(currentIndex - 1));
            audioEditorUtils.addActionToHistory();
            audioEditorUtils.checkMarkerPositionForCurrentSlide();
        }
    } else {
        if (currentIndex < (slides.length - 1)) {
            dispatch(setCurrentSlide(currentIndex + 1));
            audioEditorUtils.addActionToHistory();
            audioEditorUtils.checkMarkerPositionForCurrentSlide();
        }
    }

    saveManager.isContentChanged(true);
}

function changeSlidePosition (dispatch, isLeft) {
    const state = storeManager.getState();
    const currentIndex = state.currentSlide.currentSlideIndex;
    const slides = state.production.slides;
    var newSlideIndex = -1;
    const currentSlideUid = state.currentSlide.model.uuid;

    if (isLeft == true) {
        if (currentIndex > 0) {
            dispatch(shiftSlide(isLeft, currentIndex));
            newSlideIndex = currentIndex - 1;
        }
    } else {
        if (currentIndex < (slides.length - 1)) {
            dispatch(shiftSlide(isLeft, currentIndex));
            newSlideIndex = currentIndex + 1;
        }
    }

    if (newSlideIndex != -1) {
        dispatch(updateCurrentSlideIndex(currentSlideUid));
        audioEditorUtils.addActionToHistory();
        zoomUtils.closeZoom();
    }

    saveManager.isContentChanged(true);
}

function changeFontProperties(dispatch, propertyType, stepOffset) {
    const shapeModel = getSelectedShape();

    if (!shapeModel || !isTextBox(shapeModel))
        return;

    dispatch(updateTextProperties(shapeModel, propertyType, stepOffset));
    audioEditorUtils.addActionToHistory();

    checkSize(dispatch);
    saveManager.isContentChanged(true);
}

function checkSize(dispatch) {
    const shapeModel = getSelectedShape();

    textSizeUtils.updateTextWrapperSize(shapeModel, dispatch);
}

function copyShape(dispatch) {
    var shapeModel = getShapeTarget();

    if (shapeModel && mindMapUtils.isMindMapType(shapeModel))
        return;

    const state = storeManager.getState();
    selectionManager.copiedCanvasElement = true;
    selectionManager.currentSlide = state.currentSlide.model;

    if (shapeModel) {
        dispatch(setCloneTarget(shapeModel));
        saveManager.isContentChanged(true);
    }
}

function cutShape(dispatch) {
    var shapeModel = getShapeTarget();

    if (shapeModel && mindMapUtils.isMindMapType(shapeModel))
        return;

    const state = storeManager.getState();
    selectionManager.copiedCanvasElement = true;
    selectionManager.currentSlide = state.currentSlide.model;

    if (shapeModel) {
        dispatch(setCloneTarget(shapeModel));

        dispatch(deleteShape([shapeModel.uuid]));
        dispatch(selectShape(''));
        audioEditorUtils.addActionToHistory();
        updateThumbnail(dispatch);
        saveManager.isContentChanged(true);
    }
}

function isDurationFocus() {
    var isTextFocus = false;
    var element = document.activeElement;

    if (!element)
        return false;

    var type = typeof element.className;

    if (element && type == 'string' && element.className.indexOf('slideDuration') != -1)
        isTextFocus = true;

    return isTextFocus;
}

function isTextFocus() {
    var isTextFocus = false;
    var element = document.activeElement;
    var type = typeof element.className;

    if (element && type == 'string' && (element.className.indexOf('textShapes') != -1 || element.className.indexOf('titleInput') != -1))
        isTextFocus = true;

    return isTextFocus;
}

function removeTextBoxesFocus() {
    const elements = document.getElementsByClassName('textShapes');
    var i;

    for (i=0; i<elements.length; i++)
        elements[i].blur();
}

function getCloneTarget () {
    const state = storeManager.getState();
    const cloneTarget = state.currentSlide.cloneTarget;
    const shapes = state.currentSlide.model.content;
    var i;
    var target;

    if (cloneTarget == undefined)
        return target;

    for (i=0; i<shapes.length; i++)
        if (shapes[i].uuid == cloneTarget.uuid)
            target = shapes[i];

    if (!target)
        target = cloneTarget;

    return target;
}

function pasteShape(dispatch) {
    const state = storeManager.getState();
    const cloneTarget = getCloneTarget();

    if (cloneTarget != undefined) {
        if (mindMapUtils.isMindMapType(cloneTarget))
            return;

        removeTextBoxesFocus();

        dispatch(duplicateShape(cloneTarget));
        updateThumbnail(dispatch);

        const shapesArray = state.currentSlide.model.content;
        const lastDuplicatedShape = shapesArray[shapesArray.length - 1];
        dispatch(setCloneTarget(lastDuplicatedShape));
        audioEditorUtils.addActionToHistory();
        dispatch(selectLastAddedShape());
        saveManager.isContentChanged(true);
    }
}

function getCurrentSlide() {
    const state = storeManager.getState();

    return state.currentSlide.model;
}

function copySlide(dispatch) {
    var slide = getCurrentSlide();

    selectionManager.copiedCanvasElement = false;
    dispatch(setSlideCloneTarget(slide));
    saveManager.isContentChanged(true);
}

function cutSlide(dispatch) {
    var slide = getCurrentSlide();

    dispatch(selectShape('slideFocus'));
    dispatch(updateCurrentSlide());

    dispatch(setSlideCloneTarget(slide));

    const state = storeManager.getState();
    const slides = state.production.slides;
    let newSlideIndex;

    if (slides.length == 1) {
        newSlideIndex = 0;
    }
    else {
        if (slides.length - 1 == state.currentSlide.currentSlideIndex)
            newSlideIndex = state.currentSlide.currentSlideIndex - 1;
        else
            newSlideIndex = state.currentSlide.currentSlideIndex;
    }

    selectionManager.copiedCanvasElement = false;

    dispatch(deleteSlide());
    dispatch(setCurrentSlide(newSlideIndex));
    dispatch(needsRefresh(true));
    audioEditorUtils.addActionToHistory();
    audioEditorUtils.checkMarkerPositionForCurrentSlide();
    audioEditorUtils.checkTimelineWidth(true);
    saveManager.isContentChanged(true);
}

function pasteSlide(dispatch) {
    const state = storeManager.getState();
    const target = state.production.slideCloneTarget;

    if (target) {
        dispatch(selectShape('slideFocus'));
        dispatch(updateCurrentSlide());
        dispatch(cloneSlide(target));
        dispatch(setCurrentSlide(state.currentSlide.currentSlideIndex + 1));
        dispatch(needsRefresh(true));
        audioEditorUtils.addActionToHistory();
        audioEditorUtils.checkMarkerPositionForCurrentSlide();
        audioEditorUtils.checkTimelineWidth(true);
        saveManager.isContentChanged(true);
    }
}

export function undoAction(dispatch) {
    const state = storeManager.getState();
    const undoHistory = state.undoRedo.undo;

    if (undoHistory && undoHistory.length > 0) {
        dispatch(undo());
        setTimeout(updateStateToPresent, 10);
        saveManager.isContentChanged(true);
    }
}

export function redoAction(dispatch) {
    const state = storeManager.getState();
    const redoHistory = state.undoRedo.redo;

    if (redoHistory && redoHistory.length > 0) {
        dispatch(redo());
        setTimeout(updateStateToPresent, 10);
        saveManager.isContentChanged(true);
    }
}

function updateStateToPresent() {
    const state = storeManager.getState();
    const present = state.undoRedo.present;
    const dispatch = storeManager.getStore().dispatch;

    slidesUtils.updateAllThumbnails = true;

    dispatch(canvasUndoRedoAction(present));
    dispatch(productionUndoRedoAction(present));
    dispatch(audioEditorUndoRedo(present));

    dispatch(hideMenus(menuConstants.ALL_MENUS));
    dispatch(selectShape('slideFocus'));
    updateThumbnail(dispatch);

    saveManager.isContentChanged(true);
}

function openSaveMenu(dispatch) {
    dispatch(updateCurrentSlide());
    dispatch(changeContextMode(modeType.SAVE_CONTEXT));
}

function updateSlideZoom(zoomType) {
    const event = new CustomEvent("ZoomTransformEvent", {detail: zoomType});
    document.dispatchEvent(event);
}


/** WEBPACK FOOTER **
 ** ./src/components/utils/KeyboardShortcuts.js
 **/